import { render, staticRenderFns } from "./UserPurview.vue?vue&type=template&id=e7a74a06&scoped=true"
import script from "./UserPurview.vue?vue&type=script&lang=js"
export * from "./UserPurview.vue?vue&type=script&lang=js"
import style0 from "./UserPurview.vue?vue&type=style&index=0&id=e7a74a06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7a74a06",
  null
  
)

export default component.exports